import PosthogService from '~/services/posthog/PosthogService';

export interface IBulkConfirmCandidateViewedPayload {
  professionalId?: string;
  candidateId?: string;
  /** How many of the professional's pending shifts were presented. */
  shiftCount: number;
  /** The shifts presented. Plural because this is one candidate across N shifts. */
  shiftIds?: string[];
  offerIds?: string[];
}

/**
 * Impression event for the bulk "Confirm Shifts" page — the bulk-flow counterpart
 * to dental_portal:confirm_candidate:candidate_viewed (GOTU-4815).
 *
 * Fires ONCE per candidate presented, which on this page means once per page view:
 * the bulk flow is scoped to a single professional shown against N of their pending
 * shifts. Hence `candidate_count` / `candidate_number` are always 1.
 *
 * The shifts presented are reported as `shift_ids` / `offer_ids` rather than a
 * single shift_id — there is no one shift at candidate level. Joining those against
 * confirm_clicked's shift_ids is what surfaces shifts shown but never confirmed.
 *
 * Event: dental_portal:bulk_confirm:candidate_viewed
 */
export function fireBulkConfirmCandidateViewed(
  payload: IBulkConfirmCandidateViewedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:bulk_confirm:candidate_viewed', {
    professional_id: payload.professionalId,
    candidate_id: payload.candidateId,
    shift_count: payload.shiftCount,
    shift_ids: payload.shiftIds,
    offer_ids: payload.offerIds,
    // Invariant of this flow, not a caller concern: the bulk page is scoped to a
    // single professional. Hardcoded so a shift count can never leak in here.
    candidate_number: 1,
    candidate_count: 1,
  });
}
